import { css } from 'styled-components';
import { getThemeData } from '@hzero-front-ui/core';
var Result = function Result(props) {
  var _getThemeData = getThemeData(props, 'result'),
    iconSize = _getThemeData.iconSize,
    titleFontSize = _getThemeData.titleFontSize,
    subTitleFontSize = _getThemeData.subTitleFontSize,
    iconMarginB = _getThemeData.iconMarginB,
    titleLineHeight = _getThemeData.titleLineHeight,
    subTFontHeight = _getThemeData.subTFontHeight,
    buttonMarginT = _getThemeData.buttonMarginT,
    titleBottom = _getThemeData.titleBottom;
  var _getThemeData2 = getThemeData(props, 'common'),
    successColor = _getThemeData2.successColor,
    infoColor = _getThemeData2.infoColor,
    errorColor = _getThemeData2.errorColor,
    warningColor = _getThemeData2.warningColor,
    titleColor1 = _getThemeData2.titleColor1,
    titleColor3 = _getThemeData2.titleColor3,
    iconfontFamily = _getThemeData2.iconfontFamily;
  return css([".c7n-result.c7n-result{.c7n-result-icon{margin-bottom:", "px;.icon{font-size:", "px;line-height:0;}}.c7n-result-title{font-size:", "px;color:", ";line-height:", "px;margin-bottom:", "px;}.c7n-result-subtitle{font-size:", "px;line-height:", "px;color:", ";}.c7n-result-extra{margin-top:", "px;line-height:0;> *{margin-right:0;}}&.c7n-result-success{.icon{color:", ";}}&.c7n-result-info{.icon{color:", ";}}&.c7n-result-warning{.icon{color:", ";:before{content:'\\e79b';font-family:", ";}}}&.c7n-result-error{.icon{color:", ";:before{content:'\\e734';font-family:", ";}}}}"], iconMarginB, iconSize, titleFontSize, titleColor1, titleLineHeight, titleBottom, subTitleFontSize, subTFontHeight, titleColor3, buttonMarginT, successColor, infoColor, warningColor, iconfontFamily, errorColor, iconfontFamily);
};
export default Result;